import { get_platform3348u7kp42j9x as get_platform } from './PlatformUtils.js.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { get_isDevelopmentMode9gzo38yad2no as get_isDevelopmentMode } from './PlatformUtils.web.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var PlatformUtilsClass;
function PlatformUtils() {
  if (PlatformUtilsClass === VOID) {
    class $ {
      constructor() {
        PlatformUtils_instance = this;
        var tmp = this;
        var platform = get_platform(this);
        var tmp_0;
        if (platform instanceof Js()) {
          tmp_0 = platform.jsPlatform_1.equals(JsPlatform_Browser_getInstance());
        } else {
          if (platform instanceof WasmJs()) {
            tmp_0 = platform.jsPlatform_1.equals(JsPlatform_Browser_getInstance());
          } else {
            tmp_0 = false;
          }
        }
        tmp.IS_BROWSER_1 = tmp_0;
        var tmp_1 = this;
        var platform_0 = get_platform(this);
        var tmp_2;
        if (platform_0 instanceof Js()) {
          tmp_2 = platform_0.jsPlatform_1.equals(JsPlatform_Node_getInstance());
        } else {
          if (platform_0 instanceof WasmJs()) {
            tmp_2 = platform_0.jsPlatform_1.equals(JsPlatform_Node_getInstance());
          } else {
            tmp_2 = false;
          }
        }
        tmp_1.IS_NODE_1 = tmp_2;
        var tmp_3 = this;
        var tmp_4 = get_platform(this);
        tmp_3.IS_JS_1 = tmp_4 instanceof Js();
        var tmp_5 = this;
        var tmp_6 = get_platform(this);
        tmp_5.IS_WASM_JS_1 = tmp_6 instanceof WasmJs();
        this.IS_JVM_1 = equals(get_platform(this), Jvm_getInstance());
        this.IS_NATIVE_1 = equals(get_platform(this), Native_getInstance());
        this.IS_DEVELOPMENT_MODE_1 = get_isDevelopmentMode(this);
        this.IS_NEW_MM_ENABLED_1 = true;
      }
    }
    initMetadataForObject($, 'PlatformUtils');
    PlatformUtilsClass = $;
  }
  return PlatformUtilsClass;
}
var PlatformUtils_instance;
function PlatformUtils_getInstance() {
  if (PlatformUtils_instance === VOID)
    new (PlatformUtils())();
  return PlatformUtils_instance;
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  JsPlatform_Browser_instance = new (JsPlatform())('Browser', 0);
  JsPlatform_Node_instance = new (JsPlatform())('Node', 1);
}
var JsPlatform_Browser_instance;
var JsPlatform_Node_instance;
var JvmClass;
function Jvm() {
  if (JvmClass === VOID) {
    class $ extends Platform() {
      constructor() {
        Jvm_instance = null;
        super();
        Jvm_instance = this;
      }
      toString() {
        return 'Jvm';
      }
      hashCode() {
        return 1051825272;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Jvm()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Jvm');
    JvmClass = $;
  }
  return JvmClass;
}
var Jvm_instance;
function Jvm_getInstance() {
  if (Jvm_instance === VOID)
    new (Jvm())();
  return Jvm_instance;
}
var NativeClass;
function Native() {
  if (NativeClass === VOID) {
    class $ extends Platform() {
      constructor() {
        Native_instance = null;
        super();
        Native_instance = this;
      }
      toString() {
        return 'Native';
      }
      hashCode() {
        return -1059277600;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Native()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Native');
    NativeClass = $;
  }
  return NativeClass;
}
var Native_instance;
function Native_getInstance() {
  if (Native_instance === VOID)
    new (Native())();
  return Native_instance;
}
var JsClass;
function Js() {
  if (JsClass === VOID) {
    class $ extends Platform() {
      constructor(jsPlatform) {
        super();
        this.jsPlatform_1 = jsPlatform;
      }
      toString() {
        return 'Js(jsPlatform=' + this.jsPlatform_1.toString() + ')';
      }
      hashCode() {
        return this.jsPlatform_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Js()))
          return false;
        if (!this.jsPlatform_1.equals(other.jsPlatform_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Js');
    JsClass = $;
  }
  return JsClass;
}
var WasmJsClass;
function WasmJs() {
  if (WasmJsClass === VOID) {
    class $ extends Platform() {}
    initMetadataForClass($, 'WasmJs');
    WasmJsClass = $;
  }
  return WasmJsClass;
}
var JsPlatformClass;
function JsPlatform() {
  if (JsPlatformClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'JsPlatform');
    JsPlatformClass = $;
  }
  return JsPlatformClass;
}
function JsPlatform_Browser_getInstance() {
  static_init();
  return JsPlatform_Browser_instance;
}
function JsPlatform_Node_getInstance() {
  static_init();
  return JsPlatform_Node_instance;
}
var PlatformClass;
function Platform() {
  if (PlatformClass === VOID) {
    class $ {}
    initMetadataForClass($, 'Platform');
    PlatformClass = $;
  }
  return PlatformClass;
}
//region block: exports
export {
  JsPlatform_Browser_getInstance as JsPlatform_Browser_getInstancegulug8f3gckh,
  JsPlatform_Node_getInstance as JsPlatform_Node_getInstance2csp0pb5ugtrk,
  PlatformUtils_getInstance as PlatformUtils_getInstancezyao53u70tqo,
  Js as Js3mqqtifz3qrzp,
};
//endregion

//# sourceMappingURL=PlatformUtils.mjs.map
